import { RootState } from "../../../../store";
import { getPermissionsSelector } from "../getPermissionsSelector";

export const userRolePermissionsGettingLoadingSelector = (state: RootState) => {
  return getPermissionsSelector(state)?.isLoading;
};
